import { environment } from 'src/environments/environment';
import SuperTokens from 'supertokens-web-js';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword';
import Session from 'supertokens-web-js/recipe/session';

const API_PATH_PREFIX = '/api/';
const AUTH_PATH_PREFIX = '/auth';
const FRONT_TOKEN_COOKIE_NAME = 'sFrontToken=';
const LAST_ACCESS_TOKEN_UPDATE_COOKIE_NAME = 'st-last-access-token-update=';

function getCurrentPathname(): string {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location.pathname ?? '';
}

function getCurrentOrigin(): string {
  if (typeof window === 'undefined') {
    return 'http://localhost';
  }

  return window.location.origin;
}

export function hasLocalSessionHint(cookieHeader: string = typeof document === 'undefined' ? '' : (document.cookie ?? '')): boolean {
  return cookieHeader.includes(FRONT_TOKEN_COOKIE_NAME) || cookieHeader.includes(LAST_ACCESS_TOKEN_UPDATE_COOKIE_NAME);
}

export function shouldSkipAuthRouteSessionProbe(pathname: string = getCurrentPathname(), cookieHeader?: string): boolean {
  return pathname.startsWith(AUTH_PATH_PREFIX) && !hasLocalSessionHint(cookieHeader);
}

export function shouldInterceptWithSuperTokens(
  toCheckUrl: string,
  baseOrigin: string = getCurrentOrigin()
): boolean {
  try {
    const resolvedUrl = new URL(toCheckUrl, baseOrigin);
    return resolvedUrl.pathname.startsWith(API_PATH_PREFIX);
  } catch {
    return false;
  }
}

function createSessionRecipe() {
  return Session.init({
    override: {
      functions: (originalImplementation) => ({
        ...originalImplementation,
        doesSessionExist: (input) => {
          if (shouldSkipAuthRouteSessionProbe()) {
            return Promise.resolve(false);
          }

          return originalImplementation.doesSessionExist(input);
        },
        getUserId: (input) => {
          if (shouldSkipAuthRouteSessionProbe()) {
            throw new Error('No session exists');
          }

          return originalImplementation.getUserId(input);
        },
        getAccessTokenPayloadSecurely: (input) => {
          if (shouldSkipAuthRouteSessionProbe()) {
            throw new Error('No session exists');
          }

          return originalImplementation.getAccessTokenPayloadSecurely(input);
        },
        shouldDoInterceptionBasedOnUrl: (toCheckUrl, apiDomain, sessionTokenBackendDomain) => {
          if (!shouldInterceptWithSuperTokens(toCheckUrl)) {
            return false;
          }

          return originalImplementation.shouldDoInterceptionBasedOnUrl(toCheckUrl, apiDomain, sessionTokenBackendDomain);
        }
      })
    }
  });
}

export function initSuperTokensUI() {
  console.log('Initializing SuperTokens UI with API domain:', environment);
  SuperTokens.init({
    appInfo: {
      apiDomain: environment.SUPERTOKENS_API_DOMAIN,
      apiBasePath: '/api/auth',
      appName: 'nt25'
    },

    recipeList: [createSessionRecipe(), EmailPassword.init()]
  });
}

export function initSuperTokensWebJS() {
  SuperTokens.init({
    appInfo: {
      appName: 'nt25',
      apiDomain: 'http://localhost:34200',
      apiBasePath: '/api/auth'
    },
    recipeList: [createSessionRecipe()]
  });
}
